import { createTemplateFactory } from "@ember/template-factory";
export default createTemplateFactory(
/*
  <section class="group-name">
  <label>{{i18n "tagging.groups.name_placeholder"}}</label>
  <div><TextField @value={{this.buffered.name}} /></div>
</section>

<section class="group-tags-list">
  <label>{{i18n "tagging.groups.tags_label"}}</label><br />
  <TagChooser
    @tags={{this.buffered.tag_names}}
    @everyTag={{true}}
    @unlimitedTagCount={{true}}
    @excludeSynonyms={{true}}
    @options={{hash
      allowAny=true
      filterPlaceholder="tagging.groups.tags_placeholder"
    }}
  />
</section>

<section class="parent-tag-section">
  <label>{{i18n "tagging.groups.parent_tag_label"}}</label>
  <div>
    <TagChooser
      @tags={{this.buffered.parent_tag_name}}
      @everyTag={{true}}
      @excludeSynonyms={{true}}
      @options={{hash
        allowAny=true
        filterPlaceholder="tagging.groups.parent_tag_placeholder"
        maximum=1
      }}
    />
  </div>
  <div class="description">{{i18n
      "tagging.groups.parent_tag_description"
    }}</div>
</section>

<section class="group-one-per-topic">
  <label>
    <Input
      @type="checkbox"
      @checked={{this.buffered.one_per_topic}}
      name="onepertopic"
    />
    {{i18n "tagging.groups.one_per_topic_label"}}
  </label>
</section>

<section class="group-visibility">
  <div class="group-visibility-option">
    <RadioButton
      @name="tag-permissions-choice"
      @value="public"
      @id="public-permission"
      @selection={{this.buffered.permissionName}}
      @onChange={{action "setPermissionsType"}}
      class="tag-permissions-choice"
    />

    <label class="radio" for="public-permission">
      {{i18n "tagging.groups.everyone_can_use"}}
    </label>
  </div>
  <div class="group-visibility-option">
    <RadioButton
      @name="tag-permissions-choice"
      @value="visible"
      @id="visible-permission"
      @selection={{this.buffered.permissionName}}
      @onChange={{action "setPermissionsType"}}
      class="tag-permissions-choice"
    />

    <label class="radio" for="visible-permission">
      {{i18n "tagging.groups.usable_only_by_groups"}}
    </label>

    <div class="group-access-control">
      <GroupChooser
        @content={{this.allGroups}}
        @value={{this.selectedGroupIds}}
        @labelProperty="name"
        @onChange={{action "setPermissionsGroups"}}
        @options={{hash
          filterPlaceholder="tagging.groups.select_groups_placeholder"
        }}
      />
    </div>
  </div>
  <div class="group-visibility-option">
    <RadioButton
      @name="tag-permissions-choice"
      @value="private"
      @id="private-permission"
      @selection={{this.buffered.permissionName}}
      @onChange={{action "setPermissionsType"}}
      class="tag-permissions-choice"
    />

    <label class="radio" for="private-permission">
      {{i18n "tagging.groups.visible_only_to_groups"}}
    </label>

    <div class="group-access-control">
      <GroupChooser
        @content={{this.allGroups}}
        @value={{this.selectedGroupIds}}
        @labelProperty="name"
        @onChange={{action "setPermissionsGroups"}}
        @options={{hash
          filterPlaceholder="tagging.groups.select_groups_placeholder"
        }}
      />
    </div>
  </div>
</section>

<div class="tag-group-controls">
  <DButton
    @action={{action "save"}}
    @disabled={{this.buffered.isSaving}}
    @label="tagging.groups.save"
    class="btn-primary"
  />

  <DButton
    @action={{action "destroy"}}
    @disabled={{this.buffered.isNew}}
    @icon="far-trash-alt"
    @label="tagging.groups.delete"
    class="btn-danger"
  />
</div>
*/
{
  "id": "YvXjsB3D",
  "block": "[[[10,\"section\"],[14,0,\"group-name\"],[12],[1,\"\\n  \"],[10,\"label\"],[12],[1,[28,[35,0],[\"tagging.groups.name_placeholder\"],null]],[13],[1,\"\\n  \"],[10,0],[12],[8,[39,1],null,[[\"@value\"],[[30,0,[\"buffered\",\"name\"]]]],null],[13],[1,\"\\n\"],[13],[1,\"\\n\\n\"],[10,\"section\"],[14,0,\"group-tags-list\"],[12],[1,\"\\n  \"],[10,\"label\"],[12],[1,[28,[35,0],[\"tagging.groups.tags_label\"],null]],[13],[10,\"br\"],[12],[13],[1,\"\\n  \"],[8,[39,2],null,[[\"@tags\",\"@everyTag\",\"@unlimitedTagCount\",\"@excludeSynonyms\",\"@options\"],[[30,0,[\"buffered\",\"tag_names\"]],true,true,true,[28,[37,3],null,[[\"allowAny\",\"filterPlaceholder\"],[true,\"tagging.groups.tags_placeholder\"]]]]],null],[1,\"\\n\"],[13],[1,\"\\n\\n\"],[10,\"section\"],[14,0,\"parent-tag-section\"],[12],[1,\"\\n  \"],[10,\"label\"],[12],[1,[28,[35,0],[\"tagging.groups.parent_tag_label\"],null]],[13],[1,\"\\n  \"],[10,0],[12],[1,\"\\n    \"],[8,[39,2],null,[[\"@tags\",\"@everyTag\",\"@excludeSynonyms\",\"@options\"],[[30,0,[\"buffered\",\"parent_tag_name\"]],true,true,[28,[37,3],null,[[\"allowAny\",\"filterPlaceholder\",\"maximum\"],[true,\"tagging.groups.parent_tag_placeholder\",1]]]]],null],[1,\"\\n  \"],[13],[1,\"\\n  \"],[10,0],[14,0,\"description\"],[12],[1,[28,[35,0],[\"tagging.groups.parent_tag_description\"],null]],[13],[1,\"\\n\"],[13],[1,\"\\n\\n\"],[10,\"section\"],[14,0,\"group-one-per-topic\"],[12],[1,\"\\n  \"],[10,\"label\"],[12],[1,\"\\n    \"],[8,[39,4],[[24,3,\"onepertopic\"]],[[\"@type\",\"@checked\"],[\"checkbox\",[30,0,[\"buffered\",\"one_per_topic\"]]]],null],[1,\"\\n    \"],[1,[28,[35,0],[\"tagging.groups.one_per_topic_label\"],null]],[1,\"\\n  \"],[13],[1,\"\\n\"],[13],[1,\"\\n\\n\"],[10,\"section\"],[14,0,\"group-visibility\"],[12],[1,\"\\n  \"],[10,0],[14,0,\"group-visibility-option\"],[12],[1,\"\\n    \"],[8,[39,5],[[24,0,\"tag-permissions-choice\"]],[[\"@name\",\"@value\",\"@id\",\"@selection\",\"@onChange\"],[\"tag-permissions-choice\",\"public\",\"public-permission\",[30,0,[\"buffered\",\"permissionName\"]],[28,[37,6],[[30,0],\"setPermissionsType\"],null]]],null],[1,\"\\n\\n    \"],[10,\"label\"],[14,0,\"radio\"],[14,\"for\",\"public-permission\"],[12],[1,\"\\n      \"],[1,[28,[35,0],[\"tagging.groups.everyone_can_use\"],null]],[1,\"\\n    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n  \"],[10,0],[14,0,\"group-visibility-option\"],[12],[1,\"\\n    \"],[8,[39,5],[[24,0,\"tag-permissions-choice\"]],[[\"@name\",\"@value\",\"@id\",\"@selection\",\"@onChange\"],[\"tag-permissions-choice\",\"visible\",\"visible-permission\",[30,0,[\"buffered\",\"permissionName\"]],[28,[37,6],[[30,0],\"setPermissionsType\"],null]]],null],[1,\"\\n\\n    \"],[10,\"label\"],[14,0,\"radio\"],[14,\"for\",\"visible-permission\"],[12],[1,\"\\n      \"],[1,[28,[35,0],[\"tagging.groups.usable_only_by_groups\"],null]],[1,\"\\n    \"],[13],[1,\"\\n\\n    \"],[10,0],[14,0,\"group-access-control\"],[12],[1,\"\\n      \"],[8,[39,7],null,[[\"@content\",\"@value\",\"@labelProperty\",\"@onChange\",\"@options\"],[[30,0,[\"allGroups\"]],[30,0,[\"selectedGroupIds\"]],\"name\",[28,[37,6],[[30,0],\"setPermissionsGroups\"],null],[28,[37,3],null,[[\"filterPlaceholder\"],[\"tagging.groups.select_groups_placeholder\"]]]]],null],[1,\"\\n    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n  \"],[10,0],[14,0,\"group-visibility-option\"],[12],[1,\"\\n    \"],[8,[39,5],[[24,0,\"tag-permissions-choice\"]],[[\"@name\",\"@value\",\"@id\",\"@selection\",\"@onChange\"],[\"tag-permissions-choice\",\"private\",\"private-permission\",[30,0,[\"buffered\",\"permissionName\"]],[28,[37,6],[[30,0],\"setPermissionsType\"],null]]],null],[1,\"\\n\\n    \"],[10,\"label\"],[14,0,\"radio\"],[14,\"for\",\"private-permission\"],[12],[1,\"\\n      \"],[1,[28,[35,0],[\"tagging.groups.visible_only_to_groups\"],null]],[1,\"\\n    \"],[13],[1,\"\\n\\n    \"],[10,0],[14,0,\"group-access-control\"],[12],[1,\"\\n      \"],[8,[39,7],null,[[\"@content\",\"@value\",\"@labelProperty\",\"@onChange\",\"@options\"],[[30,0,[\"allGroups\"]],[30,0,[\"selectedGroupIds\"]],\"name\",[28,[37,6],[[30,0],\"setPermissionsGroups\"],null],[28,[37,3],null,[[\"filterPlaceholder\"],[\"tagging.groups.select_groups_placeholder\"]]]]],null],[1,\"\\n    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n\"],[13],[1,\"\\n\\n\"],[10,0],[14,0,\"tag-group-controls\"],[12],[1,\"\\n  \"],[8,[39,8],[[24,0,\"btn-primary\"]],[[\"@action\",\"@disabled\",\"@label\"],[[28,[37,6],[[30,0],\"save\"],null],[30,0,[\"buffered\",\"isSaving\"]],\"tagging.groups.save\"]],null],[1,\"\\n\\n  \"],[8,[39,8],[[24,0,\"btn-danger\"]],[[\"@action\",\"@disabled\",\"@icon\",\"@label\"],[[28,[37,6],[[30,0],\"destroy\"],null],[30,0,[\"buffered\",\"isNew\"]],\"far-trash-alt\",\"tagging.groups.delete\"]],null],[1,\"\\n\"],[13]],[],false,[\"i18n\",\"text-field\",\"tag-chooser\",\"hash\",\"input\",\"radio-button\",\"action\",\"group-chooser\",\"d-button\"]]",
  "moduleName": "discourse/components/tag-groups-form.hbs",
  "isStrictMode": false
});